import BaseEditByMapPage from "../../../Base/BaseEditByMapPage";
import * as f from "../../../common/Funcs";
import React from "react";
import {CloseButton, SaveButton, SaveCloseButton} from "../../../common/Buttons";
import {BaseButton} from "../../../Base/BaseButtons";
import Logger from "../../../common/Logger";

const keyName = "RoutePreTrackPage";

export default class RoutePreTrackPage extends BaseEditByMapPage {
    static defaultProps = {
        height: '95%',
        width: '90%',
        allowNull: true
    }

    constructor(props) {
        super(props);
        const context = this;
        if (window.IasConfig.devMode) console.debug(`${keyName} constructor`, props);
        context.tableName = 'pre_routes_view';
        context.lastUserColumns = [];
        context.testType = 'pre_route';
        context.idField = 'route_id';
        context.columnsCount = [{width: '25'}, {width: '75'}];
        context.topMenuButtonNames = ['reload'];
        context.footerButtonNames = ['save', 'saveclose', 'close'];
        context.fieldsSet = [
            {title: 'Маршрут', fieldset: 'route', column: 0, pos: 1},
            {title: 'Предварительный трек', fieldset: 'pre', column: 0, pos: 2},
        ];
        context.columnsDefaults = [...context.lastUserColumns, ...[
            {column_name: 'route_id', hidden: true},
            {
                column_name: 'pre_fst',
                fieldset: 'pre',
                pos: 30,
                row: 0,
                labelMinWidth: '170px',
                labelAlign: 'left',
                disabled: true,
                readonly: true
            },
            {
                column_name: 'pre_fld',
                fieldset: 'pre',
                pos: 30,
                row: 1,
                labelMinWidth: '170px',
                labelAlign: 'left',
                disabled: true,
                readonly: true
            },
            {
                column_name: 'pre_bog',
                fieldset: 'pre',
                pos: 30,
                row: 2,
                labelMinWidth: '170px',
                labelAlign: 'left',
                disabled: true,
                readonly: true
            },
            {
                column_name: 'pre_all',
                fieldset: 'pre',
                pos: 30,
                row: 3,
                labelMinWidth: '170px',
                labelAlign: 'left',
                disabled: true,
                readonly: true
            },
         /*   {
                column_name: 'pre_path_upload',
                fieldset: 'pre',
                pos: 40,
                row: 5,
                data_type: 'upload',
                labelAlign: 'left',
                labelMinWidth: '170px'
            },*/
/*            {
                column_name: 'pre_path',
                fieldset: 'pre',
                pos: 40,
                row: 6,
                data_type: 'path',
                labelAlign: 'left',
                cls: 'route-gpx',
                path: () => `routes/`,
                button_label: 'трек',
                column_label: 'Файл предварительного трека'
            },*/
            {
                column_name: 'pre_geometry',
                fieldset: 'pre',
                pos: 90,
                row: 90,
                data_type: 'text',
                hidden: true
            },
            {
                column_name: 'geometry',
                row: 100,
                data_type: 'text',
                hidden: true
            },
        ]];

        context.subTables = [
            {
                column: 0, block: 0,
                pos: 0,
                title: 'Тесты',
                elementName: 'TestSubPanel',
                testName: 'pre_route',
                tableName: 'pre_routes',
            },
            {
                column: 1,
                block: 1,
                title: 'Карта предварительного трека',
                elementName: 'ZmuPreRouteMapSub',
                tableName: 'pre_routes',
                idName: 'route_id',
                filterString: "route_id=$route_id$",
                layerNames: [
                    {
                        layerName: 'pre_routes',
                        hidden: false,
                        type: 'own'
                    },
                    {
                        layerName: 'routeslin',
                        hidden: false,
                        type: 'own'
                    }
                ]
            }
        ];
    }

    titleFunc(context, record) {
        try {
            context.title = `Предварительный трек • ${record['route_name']}`;
        } catch (e) {
            context.title = 'Предварительный трек';
        }
        return context.title;
    }

    isApproved() {
        const context = this;
        return context.state.data?.is_approved;
    }
    addLoadpreButton() {
        const context = this;
        const key = 'loadprebutton';
        context.topMenuButtons.push(<BaseButton name={'loadprebutton'}
                                                text={'Загрузить прошлогодний трек'}
                                                tooltip={'Скопировать трек предварительного прохождения из прохождения прошлого года'}
                                                iconCls={'fa-history'}
                                                key={key}
                                                hidden={() => !context.isEditRight()}
                                                func={() => f.confirm({
                                                    title: 'Действие',
                                                    message: `Вы действительно хотите загрузить трек предварительного прохождения из прохождения прошлого года?`
                                                }, (e) => {
                                                    if (e) f.callPath({
                                                        method: 'GET',
                                                        path: `zmu/routes/${context.rowId}/loadpre`,
                                                        callback: () => {
                                                            if (context.getData) context.getData({context});
                                                            context.afterPreTrackUpdate(context);
                                                        }
                                                    })
                                                })}/>);
    }

    isEditRight() {
        const rights = this.props.rights || document.getCookie('rights');
        return f.isEditRight(rights);
    }

    setPreGeometry(context) {
        // Логирование начала процесса получения геометрии
        if (window.IasConfig.devMode) console.debug('RoutePreTrackPage.setPreGeometry: Начало получения геометрии');
        
        // Сначала пытаемся получить feature напрямую из источника карты (актуальная геометрия после редактирования)
        let feature = null;
        
        // Ищем olMap в элементах карты
        const olMap = context.olMap || context.elements?.ZmuPreRouteMapSub?.olMap;
        
        if (olMap) {
            // Пытаемся получить feature напрямую из featuresSource (актуальное состояние после редактирования)
            if (olMap.featuresSource) {
                const features = olMap.featuresSource.getFeatures();
                if (window.IasConfig.devMode) {
                    console.debug(`RoutePreTrackPage.setPreGeometry: Найдено ${features.length} features в featuresSource`);
                }
                
                // Ищем feature из pre_routes
                feature = features.find(f => {
                    const props = f.getProperties ? f.getProperties() : (f.values_ || {});
                    return props.source === 'pre_routes' || props.type === 'prepare';
                });
                
                if (!feature && features.length > 0) {
                    // Если не нашли по признаку, берем первый (обычно это наш feature)
                    feature = features[0];
                    if (window.IasConfig.devMode) {
                        console.debug('RoutePreTrackPage.setPreGeometry: Берем первый feature из featuresSource');
                    }
                }
            }
            
            // Если не нашли в featuresSource, пробуем state.features
            if (!feature && olMap.state?.features && olMap.state.features.length > 0) {
                if (window.IasConfig.devMode) {
                    console.debug(`RoutePreTrackPage.setPreGeometry: Ищем в state.features (${olMap.state.features.length} features)`);
                }
                feature = olMap.state.features.find(f => {
                    const props = f.getProperties ? f.getProperties() : (f.values_ || {});
                    return props.source === 'pre_routes' || props.type === 'prepare';
                }) || olMap.state.features[0];
            }
        }
        
        // Если все еще не нашли, используем стандартный метод
        if (!feature) {
            if (window.IasConfig.devMode) console.debug('RoutePreTrackPage.setPreGeometry: Используем context.hasGeom()');
            feature = context.hasGeom();
        }
        
        if (window.IasConfig.devMode) {
            console.debug('RoutePreTrackPage.setPreGeometry: feature найден:', !!feature);
            if (feature) {
                console.debug('RoutePreTrackPage.setPreGeometry: feature properties:', feature.getProperties ? feature.getProperties() : (feature.values_ || {}));
                if (feature.getGeometry) {
                    const geom = feature.getGeometry();
                    console.debug('RoutePreTrackPage.setPreGeometry: geometry type:', geom.getType());
                    const coords = geom.getCoordinates();
                    console.debug('RoutePreTrackPage.setPreGeometry: количество точек в геометрии:', 
                        Array.isArray(coords[0]) ? coords.length : 'не массив координат');
                }
            }
        }

        if (feature) {
            const geomType = feature.getGeometry().getType();
            const coords = feature.getGeometry().getCoordinates();
            
            // Логирование координат
            if (window.IasConfig.devMode) {
                const pointsCount = Array.isArray(coords[0]) ? coords.length : 1;
                console.debug(`RoutePreTrackPage.setPreGeometry: Геометрия типа ${geomType}, точек: ${pointsCount}`);
                console.debug('RoutePreTrackPage.setPreGeometry: Первые 3 координаты:', coords.slice(0, 3));
                console.debug('RoutePreTrackPage.setPreGeometry: Последние 3 координаты:', coords.slice(-3));
            }

            // Создаем GeoJSON в формате Feature с CRS в geometry
            const featureProps = feature.getProperties ? feature.getProperties() : {};
            // Удаляем geometry из properties, если она там есть
            delete featureProps.geometry;
            
            const geotext = {
                type: geomType,
                crs: {
                    type: "name",
                    properties: {name: "urn:ogc:def:crs:EPSG:3857"}
                },
                coordinates: coords
            };
            
            const jsonValue = JSON.stringify(geotext);
            
            // Логирование размера JSON
            if (window.IasConfig.devMode) {
                console.debug(`RoutePreTrackPage.setPreGeometry: Размер JSON геометрии: ${jsonValue.length} символов`);
                const pointsCount = Array.isArray(coords[0]) ? coords.length : 1;
                console.debug(`RoutePreTrackPage.setPreGeometry: Количество точек, которые будут отправлены: ${pointsCount}`);
            }

            if (context.elements?.pre_geometry?.field?.cmp) {
                context.elements.pre_geometry.field.cmp.setValue(jsonValue);
                if (window.IasConfig.devMode) console.debug('RoutePreTrackPage.setPreGeometry: Значение установлено в поле pre_geometry');
            } else {
                if (window.IasConfig.devMode) console.warn('RoutePreTrackPage.setPreGeometry: Поле pre_geometry не найдено в elements');
            }
        } else {
            if (window.IasConfig.devMode) console.warn('RoutePreTrackPage.setPreGeometry: Feature не найден, устанавливаем null');
            if (context.elements?.pre_geometry?.field?.cmp) {
                context.elements.pre_geometry.field.cmp.setValue('null');
            } else {
            }
        }
    }

    /*afterPreTrackUpdate(context) {
        // Обновляем карту в карточке редактирования трека (ZmuPreRouteMapSub) после сохранения геометрии
        if (context.elements?.ZmuPreRouteMapSub?.getData) {
            context.elements.ZmuPreRouteMapSub.getData({context: context.elements.ZmuPreRouteMapSub});
        }
        // Обновляем данные в карточке редактирования трека (расчеты протяженности)
        // Используем небольшую задержку, чтобы данные успели сохраниться на сервере
        setTimeout(() => {
            if (context.getData) {
                context.getData({context});
            }
            // Обновляем тесты в RoutePreTrackPage
            if (context.elements?.TestSubPanel?.grid?.getData) {
                context.elements.TestSubPanel.grid.getData({context: context.elements.TestSubPanel.grid, repeat: true});
            }
        }, 1000);
        // Получаем доступ к RoutePage через RoutePreTrackSub
        if (routePage?.getData) {
            // Обновляем данные в карточке маршрута (включая расчеты протяженности)
            // Обновляем карту в RoutePage после сохранения изменений трека
            if (routePage.elements?.ZmuRouteMapSub?.getData) {
                routePage.elements.ZmuRouteMapSub.getData({context: routePage.elements.ZmuRouteMapSub});
            }
            // Обновляем тесты в RoutePage
            if (routePage.elements?.TestSubPanel?.grid?.getData) {
                routePage.elements.TestSubPanel.grid.getData({context: routePage.elements.TestSubPanel.grid, repeat: true});
            }
        }
        if (context.props.onSaved) {
            context.props.onSaved(context);
        }
    }*/
    onCancel(context) {
        window.unmask();
        context.props.parent.hideEditPanel(context.props.parent);
        const routePage = context.props.routeParent || context.props.parent?.props?.parent;
        routePage?.getData?.({context: routePage});
    }
    getFooterButtons(buttons) {
        const context = this;
        const result = [];
        buttons.map(b => {
            switch (b) {
                case 'save':
                    if (context.isEditRight())
                        result.push(<SaveButton key={`${b}Button`} name={`${b}Button`}
                                                func={() => {
                                                    context.setPreGeometry(context);
                                                    context.onSave({
                                                        context,
                                                        path: `zmu/pre_routes/update/`,
                                                        callback: (res) => {
                                                            if (res?.data && res.state) {
                                                                context.getData({context});
                                                            }
                                                          //  if (res?.state) context.afterPreTrackUpdate(context);
                                                        }
                                                    })
                                                }}/>);
                    break;
                case 'saveclose':
                    if (context.isEditRight())
                        result.push(<SaveCloseButton key={`${b}Button`} name={`${b}Button`} text={`${b}Button`}
                                                     func={() => {
                                                         const beforeValue = context.elements?.pre_geometry?.field?.cmp?.getValue?.()?.substring?.(0, 100) || 'not set';
                                                         context.setPreGeometry(context);
                                                         const afterValue = context.elements?.pre_geometry?.field?.cmp?.getValue?.()?.substring?.(0, 100) || 'not set';
                                                         context.onSave({
                                                             context,
                                                             close: true,
                                                             path: `zmu/pre_routes/update/`,
                                                             callback: (res) => {
                                                                 // Если сервер вернул обновленные данные, обновляем форму с расчетами протяженности
                                                                 if (res?.data && res.state) {
                                                                     // Обновляем данные в текущей карточке редактирования трека перед закрытием
                                                                     context.getData({context});
                                                                 }
                                                               //  if (res?.state) context.afterPreTrackUpdate(context);
                                                             }
                                                         })
                                                     }}/>);
                    break;
                case 'close':
                    result.push(<CloseButton key={`${b}Button`} name={`${b}Button`} text={`${b}Button`}
                                             func={() => context.onCancel(context)}/>);
                    break;
            }
        });
        return result;
    }
}

